(function(){
    angular.module('tmx-app').directive('tmxTextArea',[tmxTextArea]);

    function tmxTextArea(){
        return {
            scope:{
                required:"@",
                disabled:"@",
                value:"=",
                label:"@",
                name:"@",
                form:"="
            },
            restrict:'E',
            templateUrl:"common/directives/tmxtextareadialog/tmxtextareadialog.html",
            controller:["$scope","$mdDialog","$state","tmxUtility","userInputRestrictions", tmxTextAreaCtrl],
            controllerAs:"tmxTextAreaCtrl"

        };//return end
    }//directive end

    function tmxTextAreaCtrl($scope,$mdDialog,$state, tmxUtility,userInputRestrictions) {
        var textareaCtrl = this;
        textareaCtrl.scope=$scope;
        textareaCtrl.scope.pattern = userInputRestrictions.pattern[7];
        if(!angular.isDefined($scope.value) || $scope.value==null){
            $scope.value = "";
        }
        textareaCtrl.enteredText = $scope.value;//for passing to dialog scope
        textareaCtrl.description = $scope.value;//for display in main
        if(textareaCtrl.description != "" || textareaCtrl.description!=null){
            if((textareaCtrl.description).length > 50){
                 
                textareaCtrl.description = tmxUtility.sliceText(textareaCtrl.description,50) + "...";
            }
        }

        /////////////////////////  REQUIRED NOT DEFINED ///////////////////
        if(!angular.isDefined(textareaCtrl.scope.required)){
            textareaCtrl.scope.required = false;
        }

        if(!angular.isDefined(textareaCtrl.scope.disabled)){
            textareaCtrl.scope.disabled = false;
        }

///////////////////////////// FUNCTIONS //////////////////////////////////////////////////////////
        textareaCtrl.textAreaDialog=function(ev){
            $mdDialog
                .show({
                    locals:{enteredText: angular.copy(textareaCtrl.enteredText), pattern:textareaCtrl.scope.pattern},
                    controller: ["$scope", "$mdDialog", "$state","enteredText","pattern",'tmxUtility',DialogController],
                    controllerAs: 'dialogCtrl',
                    templateUrl: "common/directives/tmxtextareadialog/description.dialog.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    disableParentScroll:false,
                    hasBackdrop:false
                }).then(function(answer){
                     
                    textareaCtrl.enteredText = answer;//dialog scope
                    textareaCtrl.description = answer;//main directive scope for display
                    $scope.value = answer;//passing back to Role Management controller
                    if((textareaCtrl.description).length > 50){
                         
                        textareaCtrl.description = tmxUtility.sliceText(textareaCtrl.description,50) + "...";
                    }
                });
        }
    } //controller function for directive
    /////////////////////// CONTROLLER FOR DIALOG //////////////////////////////////
    function DialogController($scope, $mdDialog, $state,enteredText,pattern,tmxUtility){
         
        var vm = this;
        vm.pattern = pattern;
        vm.enteredText = enteredText;


        $scope.cancel = function (answer) {
            $mdDialog.cancel(answer);
        };
        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.answer = function (answer) {
            $mdDialog.hide(answer);
        };
    }//dialog controller function end
})();//page end